export default __webpack_public_path__ + "static/SLR_Pressemeldung_1_1_en-27a70f2652b80c5c491597b0c760c990.jpg";